import axios from "../../department-viags/config.service";

export type RolePermissions = {
    id: number;
    roleId: number;
    permissionId: number;
    roleName?: string;
    permissionName?: string;
    permissionCode?: string;
    c: boolean;
    r: boolean;
    u: boolean;
    d: boolean;
    description: string;
    note: string;
}

export interface EmployeeRole {
  id: number;
  roleName: string;
  description: string;
  note: string;
  numOfUpdate: number;
  rolePermissions: RolePermissions[];
}

export class RolePermissionService {
  static async addRolePermission(fields: RolePermissions) {
    try {
      const res = await axios.post("/rolepermisison/create", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updateRolePermission(fields: RolePermissions) {
    try {
      const res = await axios.post("/rolepermisison/update", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async deleteRolePermission(id: number) {
    try {
      const res = await axios.delete(`/rolepermisison/delete/${id}`);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }
}
